/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGasOff = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="m17.898 20.212 3.395 3.395 1.414-1.414-20-20-1.414 1.414 4.115 4.115c-.834 1.361-1.41 3.065-1.41 5.178 0 3.43 1.63 9.91 7.84 10h1.02a8.15 8.15 0 0 0 5.04-2.688zm-6.457-6.457 5.065 5.065c-.29.342-.614.653-.968.93a6 6 0 0 1-3 1.15h-.6c-1.77-.23-2.94-.74-3.31-1.46a2.23 2.23 0 0 1 0-2 6.479 6.479 0 0 1 1.74-2.34 3.571 3.571 0 0 0 1.073-1.345zm-2.262-2.262c.03.041.063.08.1.117.217.25.344.568.36.9a1.63 1.63 0 0 1-.64 1.11 8.679 8.679 0 0 0-2.24 3.09l-.05.19a12.93 12.93 0 0 1-.71-4 8.34 8.34 0 0 1 .896-3.691l2.284 2.284zm10.727 1.957a7.76 7.76 0 0 1-.1 3.021l-1.846-1.846a5.69 5.69 0 0 0-1.422-3.655 3.12 3.12 0 0 0-1.35-.8 8.168 8.168 0 0 1-.8-.36c-1.64-.86-2.65-3.19-3.13-4.59a8.34 8.34 0 0 0-1.751.952L8.123 4.788a13.439 13.439 0 0 1 3.408-1.85.972.972 0 0 0 .097-.038 1 1 0 0 1 .78.09 1 1 0 0 1 .47.63c.34 1.38 1.31 3.77 2.45 4.35.163.085.33.152.5.22l.15.06a5.09 5.09 0 0 1 2.11 1.35 7.76 7.76 0 0 1 1.818 3.85z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGasOff as GasOff };
